<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <path id="패스_3986" data-name="패스 3986" fill="none" d="M0,0H24V24H0Z" />
    <rect
      id="사각형_6743"
      data-name="사각형 6743"
      fill="#ffffff"
      width="17"
      height="12"
      transform="translate(4 4)"
    />
    <g id="그룹_9141" data-name="그룹 9141" transform="translate(0 -1)">
      <rect
        id="사각형_6729"
        data-name="사각형 6729"
        fill="#087ef7"
        width="2"
        height="2"
        transform="translate(7 9)"
      />
      <rect
        id="사각형_6730"
        data-name="사각형 6730"
        fill="#087ef7"
        width="2"
        height="2"
        transform="translate(11 9)"
      />
      <rect
        id="사각형_6731"
        data-name="사각형 6731"
        fill="#087ef7"
        width="2"
        height="2"
        transform="translate(15 9)"
      />
    </g>
    <g
      id="그룹_9140"
      data-name="그룹 9140"
      transform="translate(-616.999 -1098)"
    >
      <path
        id="빼기_17"
        data-name="빼기 17"
        fill="#d5d8dc"
        d="M18911,15304h-16a2,2,0,0,1-2-2v-12a2.012,2.012,0,0,1,2-2h16a1.938,1.938,0,0,1,1.414.589,1.913,1.913,0,0,1,.588,1.414v12a2,2,0,0,1-2,2Zm-16-14v9h16v-9Z"
        transform="translate(-18274 -14187)"
      />
      <path
        id="빼기_18"
        data-name="빼기 18"
        fill="#363c43"
        d="M18908,15310h-8v-1l2-2h4l2,2v1Z"
        transform="translate(-18275 -14190)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
